import FormControl from "../base/FormControl";

export default class InputPassword extends FormControl {

    constructor(props) {
        super(props);
        this.state.type = "password";
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    render() {
        return super.render();
    }
}